import { render, staticRenderFns } from "./AppointmentCancelCheckDetail.vue?vue&type=template&id=572df691"
import script from "./AppointmentCancelCheckDetail.vue?vue&type=script&lang=js"
export * from "./AppointmentCancelCheckDetail.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCancelCheckDetail.vue?vue&type=style&index=0&id=572df691&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports